const DepartureCode = [
  {
    key: 'none',
    value: '出発地を選択',
    disable: false,
  },
  {
    key: 'TYO',
    value: '東京（成田空港／羽田空港）',
    disable: false,
  },
  {
    key: 'NRT',
    value: '成田空港',
    disable: false,
  },
  {
    key: 'HND',
    value: '羽田空港',
    disable: false,
  },
  {
    key: 'OSA',
    value: '大阪（関西空港／伊丹空港）',
    disable: false,
  },
  {
    key: 'KIX',
    value: '関西空港',
    disable: false,
  },
  {
    key: 'ITM',
    value: '伊丹空港',
    disable: false,
  },
  {
    key: 'NGO',
    value: '中部国際空港',
    disable: false,
  },
  {
    key: 'FUK',
    value: '福岡空港',
    disable: false,
  },
  {
    key: 'CTS',
    value: '新千歳空港',
    disable: false,
  },
  {
    key: 'OKA',
    value: '那覇空港',
    disable: false,
  },
  {
    key: '',
    value: '――――――――――――――――――――――――――――――',
    disable: true,
  },
  {
    key: 'WKJ',
    value: '稚内空港',
    disable: false,
  },
  {
    key: 'MBE',
    value: '紋別空港',
    disable: false,
  },
  {
    key: 'AKJ',
    value: '旭川空港',
    disable: false,
  },
  {
    key: 'SHB',
    value: '中標津空港',
    disable: false,
  },
  {
    key: 'KUH',
    value: '釧路空港',
    disable: false,
  },
  {
    key: 'OBO',
    value: '帯広空港',
    disable: false,
  },
  {
    key: 'MMB',
    value: '女満別空港',
    disable: false,
  },
  {
    key: 'HKD',
    value: '函館空港',
    disable: false,
  },
  {
    key: 'AOJ',
    value: '青森空港',
    disable: false,
  },
  {
    key: 'MSJ',
    value: '三沢空港',
    disable: false,
  },
  {
    key: 'ONJ',
    value: '大舘能代空港',
    disable: false,
  },
  {
    key: 'AXT',
    value: '秋田空港',
    disable: false,
  },
  {
    key: 'HNA',
    value: 'いわて花巻空港',
    disable: false,
  },
  {
    key: 'GAJ',
    value: '山形空港',
    disable: false,
  },
  {
    key: 'SYO',
    value: '庄内空港',
    disable: false,
  },
  {
    key: 'SDJ',
    value: '仙台国際空港',
    disable: false,
  },
  {
    key: 'FKS',
    value: '福島空港',
    disable: false,
  },
  {
    key: 'KIJ',
    value: '新潟空港',
    disable: false,
  },
  {
    key: 'NTQ',
    value: '能登空港',
    disable: false,
  },
  {
    key: 'TOY',
    value: '富山空港',
    disable: false,
  },
  {
    key: 'KMQ',
    value: '小松空港',
    disable: false,
  },
  {
    key: 'FSZ',
    value: '富士山静岡空港',
    disable: false,
  },
  {
    key: 'UKB',
    value: '神戸空港',
    disable: false,
  },
  {
    key: 'SHM',
    value: '南紀白浜空港',
    disable: false,
  },
  {
    key: 'OKJ',
    value: '岡山空港',
    disable: false,
  },
  {
    key: 'HIJ',
    value: '広島空港',
    disable: false,
  },
  {
    key: 'TTJ',
    value: '鳥取空港',
    disable: false,
  },
  {
    key: 'YGJ',
    value: '米子空港',
    disable: false,
  },
  {
    key: 'IZO',
    value: '出雲空港',
    disable: false,
  },
  {
    key: 'IWJ',
    value: '萩・石見空港',
    disable: false,
  },
  {
    key: 'UBJ',
    value: '山口宇部空港',
    disable: false,
  },
  {
    key: 'TAK',
    value: '高松空港',
    disable: false,
  },
  {
    key: 'TKS',
    value: '徳島空港',
    disable: false,
  },
  {
    key: 'MYJ',
    value: '松山空港',
    disable: false,
  },
  {
    key: 'KCZ',
    value: '高知空港',
    disable: false,
  },
  {
    key: 'KKJ',
    value: '北九州空港',
    disable: false,
  },
  {
    key: 'NGS',
    value: '長崎空港',
    disable: false,
  },
  {
    key: 'KMJ',
    value: '熊本空港',
    disable: false,
  },
  {
    key: 'OIT',
    value: '大分空港',
    disable: false,
  },
  {
    key: 'HSG',
    value: '佐賀空港',
    disable: false,
  },
  {
    key: 'KMI',
    value: '宮崎空港',
    disable: false,
  },
  {
    key: 'KOJ',
    value: '鹿児島空港',
    disable: false,
  },
  {
    key: 'ASJ',
    value: '奄美大島空港',
    disable: false,
  },
  {
    key: 'MMY',
    value: '宮古空港',
    disable: false,
  },
  {
    key: 'ISG',
    value: '石垣空港',
    disable: false,
  },
]

export default DepartureCode
